import { useQuery, useInfiniteQuery } from '@tanstack/react-query'
import { jobDescriptionApi } from '@/services/jobDescriptions/jobDescriptions'

export const useGetJobDescriptionById = (id: string) => {
  return useQuery({
    queryKey: ['jobDescription', id],
    queryFn: () => jobDescriptionApi.getJobDescriptionById(id),
    enabled: !!id,
  })
}

export const useGetJobDescriptionsByUserId = (userId: string) => {
  return useQuery({
    queryKey: ['jobDescriptions', userId],
    queryFn: () => jobDescriptionApi.getJobDescriptionsByUserId(userId),
    enabled: !!userId,
  })
}

export const useGetAllJobDescriptions = (
  searchQuery?: string,
  keywords?: string[],
  isTrending?: boolean,
  bu?: string
) => {
  return useInfiniteQuery({
    queryKey: ['jobDescriptions', 'all', searchQuery, keywords, isTrending, bu],
    queryFn: ({ pageParam = 1 }) =>
      jobDescriptionApi.getAllJobDescriptions(pageParam, 20, searchQuery, keywords, isTrending, bu),
    getNextPageParam: (lastPage) => {
      if (lastPage.page < lastPage.totalPages) {
        return lastPage.page + 1
      }
      return undefined
    },
    initialPageParam: 1,
  })
}

export const useGetTrendingJobDescriptions = () => {
  return useQuery({
    queryKey: ['jobDescriptions', 'trending'],
    queryFn: () => jobDescriptionApi.getTrendingJobDescriptions(),
    staleTime: 60000, // Cache for 1 minute
  })
}
